import {CompanyConfig} from '../types';
import {baseRoles, mergeWithDefaults} from './base.config';

const {labels, features, roles} = mergeWithDefaults(
  {
    order: 'Job',
    orders: 'Jobs',
    customer: 'Customer',
    customers: 'Customers',
    dispatch: 'Job Assignment',
    landlord: 'Owner',
    property: 'Company',
    properties: 'Companies',
    deliveries: 'Jobs',
  },
  {
    hasLandlordFilterOnOrders: true,
    hasServiceOnOrderCreation: true,
    hasJobDescriptionOnOrderCreation: true,
    hasPropertyDetailsOnOrderDetails: true,
    hasServicesOnOrderDetails: true,
    hasManagedPropertiesOnCompanyDetails: true,
    hasServicesOnOffering: true,
    hasLandlordFilterOnCustomers: true,
    hasPropertyFilterOnCustomers: true,
    hasMergeOrdersOnOrderList: true,
  },
  [
    ...baseRoles,
    {
      value: 'landlord',
      label: 'Owner',
      description: 'manage companies, customers and jobs',
    },
  ]
);

export const mspProviderConfig: CompanyConfig = {
  type: 'msp_provider',
  labels,
  features,
  roles,
};
